import React from 'react';
import { Footer } from '../components/HomePage';
import HowItWorksHeader from '../components/HowItWorks/HowItWorksHeader';
import AboutUs from '../components/MyProfile/ChangePassword/ChangePassword';

function ChangePasswordPage() {
  return (
    <>
      
      <AboutUs />
      <Footer />
    </>
  );
}

export default ChangePasswordPage;